<template>
    <span class="book-status-bookmark" :data-status="presentation.status" :aria-label="presentation.label" role="img">
        <svg v-if="presentation.status === 'reading'" viewBox="0 0 16 16" data-glyph="open-book" aria-hidden="true" focusable="false">
            <path d="M7.5 5.15C5.65 3.8 3.2 3.3.8 4.05l.65 6.85c2.25-.35 4.35.25 6.05 1.7V5.15Z" />
            <path d="M8.5 5.15c1.85-1.35 4.3-1.85 6.7-1.1l-.65 6.85c-2.25-.35-4.35.25-6.05 1.7V5.15Z" />
        </svg>
        <svg v-else-if="presentation.status === 'read'" viewBox="0 0 16 16" data-glyph="check" aria-hidden="true" focusable="false">
            <path d="m3 8.15 3.15 3 6.85-6.6" />
        </svg>
        <svg v-else-if="presentation.status === 'abandoned'" viewBox="0 0 16 16" data-glyph="minus" aria-hidden="true" focusable="false">
            <path d="M3.35 8h9.3" />
        </svg>
    </span>
</template>

<script lang="ts">
import { bookStatusPresentation } from '../../utils/bookStatusPresentation';

export default {
    name: 'BookStatusBookmark',
    props: { status: { type: String, default: null } },
    computed: {
        presentation() {
            return bookStatusPresentation(this.status);
        },
    },
};
</script>

<style scoped>
.book-status-bookmark {
    --bookmark-fill: rgb(var(--foxy-text-secondary));
    --bookmark-glyph: rgb(var(--foxy-surface));
    --bookmark-edge: rgb(var(--foxy-border));
    align-items: flex-start;
    background: var(--bookmark-edge);
    border: 0;
    border-radius: 0;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 0.46rem), 0 100%);
    color: var(--bookmark-glyph);
    display: inline-flex;
    filter: drop-shadow(0 0.11rem 0.13rem rgb(18 10 7 / 0.46));
    height: 2.04rem;
    justify-content: center;
    padding-top: 0.34rem;
    pointer-events: none;
    position: absolute;
    right: 0.3rem;
    top: -0.04rem;
    width: calc(1.48rem + 2px);
}

.book-status-bookmark::before {
    background: var(--bookmark-fill);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 0.43rem), 0 100%);
    content: '';
    inset: 1px;
    position: absolute;
}

.book-status-bookmark::after {
    background: linear-gradient(105deg, rgb(255 255 255 / 0.16), transparent 30%, transparent 74%, rgb(31 15 9 / 0.08));
    clip-path: polygon(0 0, 100% 0, 100% 100%, 50% calc(100% - 0.43rem), 0 100%);
    content: '';
    inset: 1px;
    position: absolute;
}

.book-status-bookmark svg {
    fill: none;
    height: 0.92rem;
    position: relative;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2.2;
    width: 0.92rem;
    z-index: 2;
}

.book-status-bookmark[data-status='reading'] svg {
    fill: currentColor;
    height: 0.9rem;
    stroke: none;
    width: 0.9rem;
}

.book-status-bookmark[data-status='read'] svg {
    height: 0.96rem;
    stroke-width: 2.8;
    width: 0.96rem;
}

.book-status-bookmark[data-status='abandoned'] svg {
    height: 0.88rem;
    stroke-width: 2.65;
    width: 0.88rem;
}

.book-status-bookmark[data-status='want_to_read'] {
    --bookmark-fill: var(--book-status-want-fill);
    --bookmark-glyph: var(--book-status-want-glyph);
    --bookmark-edge: var(--book-status-want-edge);
}

.book-status-bookmark[data-status='reading'] {
    --bookmark-fill: var(--book-status-reading-fill);
    --bookmark-glyph: var(--book-status-reading-glyph);
    --bookmark-edge: var(--book-status-reading-edge);
}

.book-status-bookmark[data-status='read'] {
    --bookmark-fill: var(--book-status-read-fill);
    --bookmark-glyph: var(--book-status-read-glyph);
    --bookmark-edge: var(--book-status-read-edge);
}

.book-status-bookmark[data-status='abandoned'] {
    --bookmark-fill: var(--book-status-dnf-fill);
    --bookmark-glyph: var(--book-status-dnf-glyph);
    --bookmark-edge: var(--book-status-dnf-edge);
}
</style>
